import createVueComponent from '../createVueComponent';

const ChevronDown = createVueComponent('ChevronDownIcon', [
  ['polyline', { points: '6 9 12 15 18 9' }],
]);

export default ChevronDown;
